import { useContext, useMemo } from 'react';

import { cx } from '@hrworks/design-system/functions';

import { ControlledCollapsibleMenuContext } from '../../ControlledCollapsibleMenuContext';
import { S } from './CollapsibleMenuBaseItem.styles';
import type { BaseItemProps } from './CollapsibleMenuBaseItem.types';

export const CollapsibleMenuBaseItem = ({
  badge,
  children,
  className,
  href,
  icon,
  id,
  onClick,
  expandToggleChildren,
  target,
  text,
  isNotClickable,
  ...otherProps
}: BaseItemProps) => {
  const { isActive, isParentExpanded } = useContext(ControlledCollapsibleMenuContext);

  const active = useMemo(() => Boolean(id && isActive(id)), [id, isActive]);

  return (
    <S.ItemContainer
      className={cx(S.cls.ItemContainer, className)}
      id={id}
      data-hasicon={Boolean(icon)}
      {...otherProps}
    >
      <S.Item
        className={S.cls.Item}
        tabIndex={isParentExpanded ? 0 : -1}
        variant="subtle"
        color="primary"
        href={href}
        target={target}
        onClick={onClick}
        $active={active}
        $showDefaultCursor={!onClick && (href === undefined || href === null)}
        data-active={active}
      >
        <S.LinkContent className={S.cls.LinkContent}>
          {icon && <S.IconContainer className={S.cls.IconContainer}>{icon}</S.IconContainer>}
          {text}
        </S.LinkContent>
        {badge}
        {expandToggleChildren}
      </S.Item>
      {children}
    </S.ItemContainer>
  );
};
